import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export function useCurrentUser() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const { data } = await api.get('/api/me');
      return data.user;
    },
  });
}
